import React from 'react';
import { Text } from '../Text';
import {StatusBadge} from '../StatusBadge';
import { StatusBadgeVariant } from '@/constants';
import { cn } from '@/utils/common_functions';

interface StatusProps {
  status: boolean;
  variant?: 'badge' | 'text' | 'visiblity';
}       
export const Status: React.FC<StatusProps> = (props) => {
  const {status, variant='text'} = props;

  if (variant == 'visiblity'){
    return <Text variant="subtitle" className={cn(status ? "text-ui_btn_green" : "")}>
      {status ? "Visible" : "Hidden"}
    </Text>
  }

  if (variant == 'badge'){
    return <StatusBadge status={status ? StatusBadgeVariant.GREEN : StatusBadgeVariant.RED}>
      {status ? "Active" : "Inactive"}
    </StatusBadge>
  }
  return (
    <Text variant="body" className="flex items-center justify-center gap-2">
      {status ? (
        <>
          <div className="size-2 rounded-full bg-ui_green" />
          <p>{'Active'}</p>
        </>
      ) : (
        <>
          <div className="size-2 rounded-full bg-ui_red" />
          <p>Blocked</p>
        </>
      )}
    </Text>
  );
};